import api from "../../../core/api";
import { Page } from "../../../shared/models/models";
import {
  PublicServiceRequest,
  ServiceBoardFilters,
  ServiceBoardQuery,
  ServiceBoardStats,
  MapViewData,
  MapViewQuery,
} from "../models/models";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.servicingApiBaseUrl };
};

const serializeParams = (params: any): string => {
  const parts: string[] = [];

  Object.keys(params).forEach(key => {
    const value = params[key];

    if (Array.isArray(value)) {
      value.forEach(item => {
        parts.push(`${key}=${encodeURIComponent(item)}`);
      });
    } else if (value !== undefined && value !== null) {
      parts.push(`${key}=${encodeURIComponent(value)}`);
    }
  });

  return parts.join('&');
};

class PublicServiceRequestsApi {
  getServiceRequestsAsync(query: ServiceBoardQuery): Promise<Page<PublicServiceRequest>> {
    return api.get<Page<PublicServiceRequest>>(`/v1/public/service-requests`, {
      ...getRequestConfig(),
      params: query,
      paramsSerializer: serializeParams
    })
      .then(x => x.data);
  }

  getServiceRequestAsync(id: string): Promise<PublicServiceRequest> {
    return api.get<PublicServiceRequest>(`/v1/public/service-requests/${id}`, getRequestConfig())
      .then(x => x.data);
  }

  getFiltersAsync(): Promise<ServiceBoardFilters> {
    return api.get<ServiceBoardFilters>(`/v1/public/service-requests/filters`, getRequestConfig())
      .then(x => x.data);
  }

  getStatsAsync(): Promise<ServiceBoardStats> {
    return api.get<ServiceBoardStats>(`/v1/public/service-requests/stats`, getRequestConfig())
      .then(x => x.data);
  }

  getMapDataAsync(query: MapViewQuery): Promise<MapViewData> {
    return api.get<MapViewData>(`/v1/public/service-requests/map`, {
      ...getRequestConfig(),
      params: query,
      paramsSerializer: serializeParams,
    })
      .then(x => x.data);
  }

  unpublishServiceRequestAsync(id: string): Promise<void> {
    return api.post<void>(`/v1/customer/service-requests/${id}/unpublish`, null, getRequestConfig())
      .then(x => x.data);
  }
}

export default new PublicServiceRequestsApi();
